import Image from "next/image";
import Link from "next/link";

import { generateBreadcrumbSchema } from "@/utils/constants";
import Head from "next/head";
import { commonStaticProps } from "@/utils/commonGetStaticProps";

export const getStaticProps = commonStaticProps(async () => {
  return {
    props: {},
  };
});
export default function NotFound() {
  const breadcrumbData = [
    {
      title: "404",
    },
  ];
  const currentUrl = "/404";
  return (
    <div suppressHydrationWarning>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateBreadcrumbSchema(breadcrumbData, currentUrl)
            ),
          }}
        />
      </Head>
      <div className="flex flex-col items-center justify-center min-h-[80vh] bg-gray-100 text-gray-900 ">
        <div className="relative  w-[30vw] md:w-[15vw] aspect-square">
          <Image
            alt="404 illustration"
            src="/images/404/404.svg"
            fill
            priority
            className="object-contain"
          />
        </div>

        <h1 className="text-3xl md:text-6xl  font-bold text-black">
          Page Not Found
        </h1>
        <p className="text-md md:text-xl mt-4 max-w-md text-center">
          We're Sorry, the page you requested could not be found. Please go back
          to the homepage.
        </p>
        <Link
          href="/"
          className="mt-6 px-4 py-2 text-white bg-black text-center hover:bg-gray-800 transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
